import styles from './hero.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import ScrollAnimation from './layout/scroll_animation'
import Media from './basic/media'

function Hero(props) {
	const fields = props.fields

	return <BlockWrapper {...props} className={classNames(styles.hero)}>
		<ScrollAnimation styles={styles}>
			<div className={styles.background}></div>
			<Media {...fields.media} settings={{texture: (fields.media.disable_grain_effect ? false : true), loading: 'eager'}} className={styles.media} />
			{fields.title &&
				<div className={styles.content_wrapper}>
					<h1>
						{fields.title && <span className={styles.title} dangerouslySetInnerHTML={{ __html: fields.title}} />}
						{fields.subtitle && <span className={styles.subtitle} dangerouslySetInnerHTML={{ __html: fields.subtitle}} />}
					</h1>
				</div>
			}
		</ScrollAnimation>
	</BlockWrapper>
}

export default Hero